import { render, staticRenderFns } from "./BankDetails.vue?vue&type=template&id=5c23f276"
import script from "./BankDetails.vue?vue&type=script&lang=js"
export * from "./BankDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports